import React from 'react';

import {
	type ActionKeys,
	ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import type {
	ActionRendererFor,
	ActionRendererKeyToPayload,
	ActionWith,
} from '@atlassian/conversation-assistant-message-actions-api/types';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

import { ArchiveTeamsCard } from './archive-teams-card';

const assertIsAtlassianTeamUpdateArchiveAction = (action: MessageAction): MessageAction => {
	if (action.key !== ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY) {
		throw new Error('Invalid action key for atlassian team update archive action');
	}
	return action;
};

export const filterAtlassianTeamUpdateArchiveActions = (
	actions: MessageAction[],
): ActionWith<ActionRendererKeyToPayload[typeof ActionKeys.AtlassianTeamUpdateArchive]>[] => {
	const filteredActions = actions.filter(assertIsAtlassianTeamUpdateArchiveAction);
	return filteredActions as ActionWith<
		ActionRendererKeyToPayload[typeof ActionKeys.AtlassianTeamUpdateArchive]
	>[];
};

export const AtlassianTeamUpdateArchiveAction = (
	props: ActionRendererFor<typeof ActionKeys.AtlassianTeamUpdateArchive>,
): React.JSX.Element => {
	return <ArchiveTeamsCard {...props} />;
};
